
export function getUserLabel(user) {
  // construct name from first and last name
  const firstName = user.getIn(['first_name'], null);
  const lastName = user.getIn(['last_name'], null);
  if (firstName || lastName) return `${firstName} ${lastName}`;

  // no first or last name, use display name
  const displayName = user.getIn(['display_name'], null);
  if (displayName) return displayName;

  // no name available - use email
  const email = user.getIn(['email']);
  return email;
}



// WEBPACK FOOTER //
// ./src/components/types/UserSelect/helpers.js